import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDate, fmtMoney } from "../../api";
import Layout from "../../components/Layout";

export default function OwnerInvoices() {
  const [invs, setInvs] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load by design
  useEffect(() => { api.get("/invoices").then((r) => setInvs(r.data)); }, []);

  const due = (invs || []).filter((i) => ["sent", "overdue"].includes(i.status));
  const paid = (invs || []).filter((i) => i.status === "paid");

  return (
    <Layout title="Invoices">
      <section className="mb-8">
        <p className="label-caps mb-3">To pay</p>
        <div className="space-y-2" data-testid="due-invoices">
          {!invs && <p className="text-muted-foreground">Loading…</p>}
          {invs && due.length === 0 && <p className="card-flat p-6 text-sm text-muted-foreground">Nothing owing. Nice.</p>}
          {due.map((i) => (
            <Link key={i.id} to={`/owner/invoices/${i.id}`} data-testid={`pay-invoice-${i.id}`}>
              <div className={`card-flat flex items-center justify-between p-4 transition-colors hover:bg-muted/50 ${i.status === "overdue" ? "border-destructive" : ""}`}>
                <div>
                  <p className="font-semibold">{i.number} · {i.property_name}</p>
                  <p className="text-sm text-muted-foreground">Sent {fmtDate(i.sent_at)}</p>
                </div>
                <div className="text-right">
                  <p className="font-heading text-lg font-bold">{fmtMoney(i.total)}</p>
                  <p className={`text-xs font-bold uppercase ${i.status === "overdue" ? "text-destructive" : "text-[hsl(43,74%,40%)]"}`}>{i.status === "overdue" ? "Overdue" : "Pay now"}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <section>
        <p className="label-caps mb-3">Paid</p>
        <div className="space-y-2" data-testid="paid-invoices">
          {paid.map((i) => (
            <Link key={i.id} to={`/owner/invoices/${i.id}`} data-testid={`paid-invoice-${i.id}`}>
              <div className="card-flat flex items-center justify-between p-4">
                <div>
                  <p className="font-semibold">{i.number} · {i.property_name}</p>
                  <p className="text-sm text-muted-foreground">Paid {fmtDate(i.paid_at)} via {i.payment_method}</p>
                </div>
                <p className="font-bold text-primary">{fmtMoney(i.total)}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
